import React, {useContext, useEffect, useState} from 'react';
//import { withRouter } from 'react-router';
import { Dropdown, Flag } from 'semantic-ui-react'
import Utility from '../../../Utility';
import './DropdownLangueSelfCheckin.css';

/**
 * Component DropdownLangue
 * Retourne un select de la langue
 * @param {string|array} props.className
 * @param {object} props.history
 * @param {object} props.match
 */
const DropdownLangueSelfCheckin = (props) => {
  /**
   * Quand on change de langue
   * @param Object event
   * @param Object data
   */
  const handleChange = (event, data) => {
    let lang = adaptionLangEn(data.value, true);
    localStorage.setItem('lang', lang);
    props.history.push(`/${props.match.params.token}/${lang}/selfCheckin`);
    window.location.reload();
  }

  /**
   * Adaption de la lanque UK en EN
   * @param string lang
   * @return string lang
   */
  const adaptionLangEn = (lang, sensUkEN) => {
    if (sensUkEN === true) {
      if (lang === 'UK') lang = 'EN';
    } else {
      if (lang === 'EN') lang = 'UK';
    }
    return lang;
  }

  /**
   * Retourne la liste des langues et la langue de la session pour le dropdown
   * @returns Object jsx
   */
  const getFormattedlanguages = () => {
    let languages = [];
    for (let i = 0; i < props.languages.length; i++) {
      // if (i > 1) continue;
      let { iso, originalName } = props.languages[i];
      languages.push({
        key: iso,
        value: iso,
        text: [<Flag name={Utility.lowerCase(iso)} key={'flag' + iso} />, <span className="spanLabelPaysSelfCheckin" key={'flag' + iso + 'Span'}>{originalName}</span>],
      });
    }
    return languages;
  }

  let languages = getFormattedlanguages();
  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <div className="langContainer">
      <Dropdown
        item
        className={'button ' + (props.className) ? props.className : null}
        defaultValue={adaptionLangEn(props.match.params.lang)}
        onChange={handleChange}
        options={languages}
      >
      </Dropdown>
    </div>

  )
}

export default DropdownLangueSelfCheckin;